import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "teams": "Teams",
          "addEditTeam": "Add/Edit Team",
          "teamMembers": "Team Members",
          "addEditMember": "Add/Edit Member",
          "userPage": "User Page",
          "projects": "Projects",
          "addEditProject": "Add/Edit Project",
          "projectDetails": "Project Details",
          "subProjectDetails": "Sub-Project Details",
          "addEditSubProject": "Add/Edit Sub-Project",
          "addEditTask": "Add/Edit Task",
          "taskDetails": "Task Details",
          "notifications": "Notifications",
        },
      },
      tr: {
        translation: {
          "teams": "Takımlar",
          "addEditTeam": "Takım Ekle/Düzenle",
          "teamMembers": "Takım Üyeleri",
          "addEditMember": "Üye Ekle/Düzenle",
          "userPage": "Kullanıcı Sayfası",
          "projects": "Projeler",
          "addEditProject": "Proje Ekle/Düzenle",
          "projectDetails": "Proje Detayları",
          "subProjectDetails": "Alt Proje Detayları",
          "addEditSubProject": "Alt Proje Ekle/Düzenle",
          "addEditTask": "Görev Ekle/Düzenle",
          "taskDetails": "Görev Detayları",
          "notifications": "Bildirimler",
        },
      },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;